import { FileText, Megaphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type TemplateInfo = {
  templateId?: string;
  params?: unknown[];
  mediaUrl?: string;
};

/**
 * Labeled chip + optional media preview for an outgoing template message. A campaign (marketing sent
 * by munchies-api, not a reply to the customer) gets its own chip so it stands out in the thread.
 */
export function TemplateContent({ template, campaign = false }: { template: TemplateInfo; campaign?: boolean }) {
  const { t } = useTranslation('conversations');

  return (
    <div className="mb-1">
      {campaign ? (
        <span
          title={t('messageView.campaignChipTitle')}
          className="inline-flex items-center gap-1 rounded-full bg-violet-100 px-2 py-0.5 text-[11px] font-medium text-violet-700 dark:bg-violet-900/40 dark:text-violet-300"
        >
          <Megaphone className="h-3 w-3" />
          {t('messageView.campaignChip')}
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 rounded-full bg-chat-accent/10 px-2 py-0.5 text-[11px] font-medium text-chat-accent-deep">
          <FileText className="h-3 w-3" />
          {t('messageView.templateChip')}
        </span>
      )}
      {template.mediaUrl && (
        <img
          src={template.mediaUrl}
          alt={t('messageView.templateMediaAlt')}
          className="mt-1.5 max-h-48 w-auto rounded-md"
          onError={(event) => {
            (event.target as HTMLImageElement).style.display = 'none';
          }}
        />
      )}
    </div>
  );
}
